import ACTIONS from '../actions.js'

export function useUIActions(dispatch) {
  return {
    setSubmitting: value => dispatch({ type: ACTIONS.SET_SUBMITTING, value }),
    setCopySuccess: value =>
      dispatch({ type: ACTIONS.SET_COPY_SUCCESS, value }),
    setField: (field, value) =>
      dispatch({ type: ACTIONS.SET_FIELD, field, value }),
    initializeForm: payload =>
      dispatch({ type: ACTIONS.INITIALIZE_FORM, payload }),
    resetForm: (params = {}, client = null, defaultAuthType = 'none') =>
      dispatch({ type: ACTIONS.RESET_FORM, params, client, defaultAuthType }),
  }
}

export default useUIActions
